import * as Sentry from '@sentry/browser';
import { browserTracingIntegration } from '@sentry/browser';
import { replayIntegration } from '@sentry/browser';
import { browserProfilingIntegration } from '@sentry/browser';
import React from 'react';
import { uiEnvironment } from 'apps/sigma2-ui/src/constants/environment';

export const instrumentSentryForUi = () => {
  if (uiEnvironment.sentryEnabled) {
    Sentry.init({
      dsn: uiEnvironment.sentryDsnUi,
      integrations: [
        browserProfilingIntegration(),
        replayIntegration(),
        browserTracingIntegration(),
      ],
      environment: uiEnvironment.sentryEnvironmentName,
      release: uiEnvironment.sentryRelease,
      tracesSampleRate: 1,
      profilesSampleRate: 1,
      sampleRate: 1,
      tracePropagationTargets: uiEnvironment.sentryTracePropagationTargets
        .split(',')
        .map((target) => new RegExp(target)),
    });
  } else {
    console.log('Sentry not enabled');
  }
};
